import { memo } from 'react';

import { useGetFooterContentQuery } from '@/shared/cms/footer';
import { useLanguage } from '@/shared/lib/hooks';

import { useGetDisclamersContentQuery } from '../../api/disclamers.api';

import cls from './global-disclamer.module.css';

export const GlobalDisclamer = memo(() => {
    const [language] = useLanguage();

    const { data: disclamerData } = useGetDisclamersContentQuery({
        locale: language,
    });

    const { data: footerData } = useGetFooterContentQuery({
        locale: language,
    });

    if (!disclamerData?.platform) return null;

    const base = process.env['ALGOTECH_CMS_URL'];

    return (
        <div
            className={cls.root}
            data-scroll-boundary="true"
        >
            {disclamerData.platform}
            {footerData?.legalNavigation && (
                <div className={cls.links}>
                    {footerData.legalNavigation.map(({ link, id }) => (
                        <span
                            key={id}
                            className={cls.link}
                        >
                            {link.type === 'reference' ? (
                                <a
                                    href={`${base}/${language}/${link.reference?.value.slug}`}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    {link.label}
                                </a>
                            ) : (
                                <a
                                    href={link.url}
                                    rel="noopener noreferrer"
                                    target="_blank"
                                >
                                    {link.label}
                                </a>
                            )}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
});

GlobalDisclamer.displayName = 'GlobalDisclamer';
